import { useState, useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Image, QRCode, Spin } from "antd";
import { Participant } from "../../models/Participant";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from "../../application/ApplicationContext";
import {
  getAllCompanyParticipants,
  getParticipant,
  sendAgainQR,
} from "../../services/ParticipantService";
import "./ParticipantOverviewPage.scss";
import User from "../../assets/user.png";
import EmailIcon from "../../assets/email-icon.png";
import PhoneIcon from "../../assets/phone-icon.png";
import type { MenuProps } from "antd";
import {
  CarryOutOutlined,
  HomeOutlined,
  ProfileOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import PersonalData from "../../components/PersonalData/PersonalData";
import BusinessData from "../../components/BusinessData/BusinessData";
import AccommodationData from "../../components/AccommodationData/AccommodationData";
import Payments from "../../components/Payments/Payments";
import { File } from "../../models/File";
import { AxiosError, AxiosResponse } from "axios";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";
import { Toast } from "primereact/toast";
import ParticipantInAgenda from "../../components/AccommodationData/ParticipantInAgenda";

const ParticipantOverviewPage = (props: any) => {
  const [oneParticipant, setOneParticipant] = useState<Participant>();
  const [activeSpinner, setActiveSpinner] = useState(false);
  let { id } = useParams();
  const { setBreadcrumb } = useApplicationContext();
  const [current, setCurrent] = useState("1");
  const status = oneParticipant?.registration.status;
  const [profilePhoto, setProfilePhoto] = useState<File | null>(null);
  const toast = useRef<any>(null);

  const location = useLocation();
  const tab = location.state;

  ///// PATH FOR IMAGES
  let serverUrl = process.env.REACT_APP_API_URL;
  let storageUrl = serverUrl + "files/storage/";
  ///// END PATH FOR IMAGES

  useEffect(() => {
    setBreadcrumb(["Učesnici", "Lista učesnika", "Profil učesnika"]);
  }, []);

  useEffect(() => {
    setActiveSpinner(true);
    if (id) {
      getParticipant(id)
        .then((response: AxiosResponse) => {
          setOneParticipant(response.data.result);
          setProfilePhoto(response.data.result.photo);
          setActiveSpinner(false);
          setCurrent("1");
          if (tab !== undefined && tab === 4) {
            setCurrent("4");
          }
        })
        .catch((err: AxiosError) => console.log(err));
    }
  }, [id]);

  // const sendQR = async () => {
  //   //download qr code, convert to base64 image
  //   const canvas = document
  //     .getElementById(`myqrcode-${oneParticipant?.registration?.id}`)
  //     ?.querySelector<HTMLCanvasElement>("canvas");
  //   let base64QrCode: string = "";
  //   if (canvas) {
  //     base64QrCode = canvas.toDataURL();
  //   }
  //   console.log("base64QrCode", base64QrCode);
  //   setActiveSpinner(true);
  //   if (oneParticipant) {
  //     sendAgainQR(oneParticipant?.id, base64QrCode).then(() => {
  //       toast?.current?.show({
  //         severity: "success",
  //         detail: `Uspešno poslat QR kod učesniku ${oneParticipant?.firstName} ${oneParticipant?.lastName}!`,
  //         life: 3000,
  //       });
  //       setActiveSpinner(false);
  //     });
  //   }
  // };

  const sendQR = async () => {
    // Download QR code, convert to base64 image
    const canvas = document
      .getElementById(`myqrcode-${oneParticipant?.registration?.id}`)
      ?.querySelector<HTMLCanvasElement>("canvas");

    let base64QrCode: string = "";

    if (canvas) {
      const borderedCanvas = document.createElement("canvas");
      borderedCanvas.width = canvas.width + 300;
      borderedCanvas.height = canvas.height + 300;
      const borderedCtx: any = borderedCanvas.getContext("2d");

      borderedCtx.fillStyle = "#ffffff";
      borderedCtx.fillRect(0, 0, borderedCanvas.width, borderedCanvas.height);
      borderedCtx.drawImage(canvas, 150, 150);

      base64QrCode = borderedCanvas.toDataURL();
    }

    console.log("base64QrCode", base64QrCode);

    setActiveSpinner(true);

    if (oneParticipant) {
      sendAgainQR(oneParticipant?.id, base64QrCode).then(() => {
        toast?.current?.show({
          severity: "success",
          detail: `Uspešno poslat QR kod učesniku ${oneParticipant?.firstName} ${oneParticipant?.lastName}!`,
          life: 3000,
        });
        setActiveSpinner(false);
      });
    }
  };

  const items: MenuProps["items"] = [
    {
      label: "Lični podaci",
      key: "1",
      icon: <ProfileOutlined />,
    },
    oneParticipant?.registration?.registrationCompanyId !== null
      ? {
          label: <span>Poslovni podaci</span>,
          key: "2",
          icon: <HomeOutlined />,
        }
      : null,
    {
      label: "Smeštaj",
      key: "3",
      icon: (
        <i
          className="bi bi-houses"
          style={{
            fontSize: "1.4rem",
            color: current === "3" ? "#C7363D" : "inherit",
            paddingRight: "0.01rem",
          }}
        ></i>
      ),
    },
    {
      label: "Prisustvo",
      key: "4",
      icon: <CarryOutOutlined />,
    },
    {
      label: (
        <>
          {oneParticipant?.active && (
            <div className="status-container">
              <div className={`${status?.replace(/ +/g, "")}`}></div>
              <p className="status-text">{status}</p>
              <CustomButton
                // danger={false}
                // htmlType={"submit"}
                // key={1}
                // type={"primary"}
                function={() => {
                  sendQR();
                }}
                text={"Pošalji QR kod"}
              />
            </div>
          )}
        </>
      ),
      key: "5",
      disabled: true,
    },
  ];

  const onClick: MenuProps["onClick"] = (e) => {
    setCurrent(e.key);
  };

  const uploadImageFunc = (image: File) => {
    setProfilePhoto(image);
  };

  return (
    <PageLayout>
      <Toast ref={toast} position={"top-right"} />
      <Spin spinning={activeSpinner}>
        <div className="participant-overview">
          <div className="inner-box">
            <div className="inner-box-left">
              {profilePhoto === null ? (
                <img className="image" alt="" src={User} />
              ) : (
                <div
                  style={{
                    backgroundImage: `url('${storageUrl}${profilePhoto?.id}')`,
                  }}
                  className="profile-photo"
                ></div>
              )}

              <div className="inner-container">
                <div className="header">
                  <p className="name">{`${oneParticipant?.firstName} ${oneParticipant?.lastName} - ${oneParticipant?.type}`}</p>
                  {oneParticipant?.registration.registrationCompanyName && (
                    <p className="company-name">
                      {oneParticipant?.registration.registrationCompanyName}
                    </p>
                  )}
                  <div className="contact-data">
                    <div className="email-box">
                      <img className="email-image" alt="" src={EmailIcon} />
                      <p className="email-text">{oneParticipant?.email}</p>
                    </div>
                    <div className="phone-box">
                      <img className="phone-image" alt="" src={PhoneIcon} />
                      <p className="phone-text">{oneParticipant?.phone}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="inner-box-right AA">
              <div id={`myqrcode-${oneParticipant?.registration?.id}`}>
                <QRCode
                  value={oneParticipant?.qrCode || "-"}
                  bgColor="#fff"
                  size={800}
                  style={{ display: "none", padding: "20px" }}
                />
              </div>

              <div id={`myqrcodeee-${oneParticipant?.registration?.id}`}>
                <QRCode
                  value={oneParticipant?.qrCode || "-"}
                  bgColor="#fff"
                  size={200}
                />
              </div>
            </div>
          </div>
          <div className="menu custom-menu-p">
            <Menu
              onClick={onClick}
              selectedKeys={[current]}
              mode="horizontal"
              items={items}
            />

            {current === "1" && (
              <PersonalData
                oneParticipant={oneParticipant}
                uploadImageFunc={uploadImageFunc}
              />
            )}
            {current === "2" && (
              <BusinessData oneParticipant={oneParticipant} />
            )}
            {current === "3" && (
              <AccommodationData oneParticipant={oneParticipant} />
            )}
            {current === "4" && (
              <ParticipantInAgenda oneParticipant={oneParticipant} />
            )}
          </div>
        </div>
      </Spin>
    </PageLayout>
  );
};

export default ParticipantOverviewPage;
